import { render } from "./Panel.vue?vue&type=template&id=7e06e2ae"
const script = {}
script.render = render

export default script